const THEME_KEY = 'zurvit-theme';
const THEME_EVENT = 'nog:theme:changed';

export type Theme = 'light' | 'dark';

export const getStoredTheme = (): Theme => {
  const saved = localStorage.getItem(THEME_KEY) as Theme | null;
  if (saved === 'light' || saved === 'dark') return saved;
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
};

export const applyTheme = (theme: Theme): void => {
  document.documentElement.setAttribute('data-theme', theme);
  localStorage.setItem(THEME_KEY, theme);
  window.dispatchEvent(new CustomEvent(THEME_EVENT, { detail: { theme } }));
};

export const onThemeChanged = (handler: (theme: Theme) => void): (() => void) => {
  const listener = (event: Event) => {
    const detail = (event as CustomEvent<{ theme?: Theme }>).detail;
    const theme = detail?.theme;
    if (theme === 'light' || theme === 'dark') {
      handler(theme);
    }
  };

  window.addEventListener(THEME_EVENT, listener as EventListener);
  return () => window.removeEventListener(THEME_EVENT, listener as EventListener);
};
